import { slicedToArray as _slicedToArray } from '../_virtual/_rollupPluginBabelHelpers.mjs';
import * as React from 'react';
import { getParentScrollElement } from '../helpers/getParentScrollElement.mjs';

function useParentScrollElement(elementRef) {
  var _React$useState = React.useState(null),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    scrollElement = _React$useState2[0],
    setScrollElement = _React$useState2[1];
  React.useEffect(function () {
    if (elementRef.current) {
      setScrollElement(getParentScrollElement(elementRef.current));
    }
  }, [elementRef.current]);
  return scrollElement;
}

export { useParentScrollElement };
